// Environnements accessibles depuis l'admin. Le choix est gardé dans le navigateur
// et appliqué au chargement (rechargement de la page à chaque bascule).
// billing à null = adresse pas encore connue pour cet environnement.
// stats : ancien service de statistiques, plus en ligne (la page Statistiques lit désormais l'API).
export const ENVIRONMENTS = [
  {
    key: 'dev',
    label: 'Dev',
    api: 'https://api.vadimm.dev',
    stats: 'https://stats.vadimm.dev',
    billing: 'https://billing.vadimm.dev',
    color: '#16a34a',
    light: '#dcfce7'
  },
  {
    key: 'preprod',
    label: 'Pré-prod',
    api: 'https://api.preprod.vadimm.fr',
    stats: null,
    billing: null,
    color: '#d97706',
    light: '#fef3c7'
  },
  {
    key: 'prod',
    label: 'Prod',
    api: 'https://api.vadimm.fr',
    stats: null,
    billing: 'https://billing.vadimm.fr',
    color: '#dc2626',
    light: '#fee2e2'
  }
]

const LOCAL = {
  key: 'local',
  label: 'Local',
  api: 'http://localhost:2000',
  stats: 'https://stats.vadimm.dev',
  billing: 'https://billing.vadimm.dev',
  color: '#475569',
  light: '#e2e8f0'
}

const STORAGE_KEY = 'vadimm-admin-env'

function readStorage (key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

// Environnement par défaut : celui du build (VUE_APP_APIROOT), sinon dev
function defaultEnv () {
  const apiRoot = process.env.VUE_APP_APIROOT
  if (!apiRoot) return ENVIRONMENTS[0]
  return ENVIRONMENTS.find(env => env.api === apiRoot) || { ...LOCAL, api: apiRoot }
}

export function currentEnv () {
  const key = readStorage(STORAGE_KEY)
  return ENVIRONMENTS.find(env => env.key === key) || defaultEnv()
}

export function switchEnv (key) {
  localStorage.setItem(STORAGE_KEY, key)
  window.location.assign('/dashboard')
}

// Chaque environnement a sa propre session
export function tokenKey (env) {
  return `vadimm-admin-token:${env.key}`
}
